import {
	Create,
	ImageInput,
	ImageField,
	NumberInput,
	SimpleForm,
	TextInput,
	BooleanInput,
} from 'react-admin';
import { Grid, Typography } from '@mui/material';

const PlanCreate = () => {
	return (
		<Create>
			<SimpleForm width={'100%'}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">תמונה</Typography>
					</Grid>
					<Grid item xs={12}>
						<ImageInput source="image" label="תמונה" accept="image/*">
							<ImageField source="src" />
						</ImageInput>
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">כותרת</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.he" label="כותרת (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.en" label="כותרת (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">תת כותרת</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="sub_title.he" label="תת כותרת (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="sub_title.en" label="תת כותרת (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">סיבה</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="reason.he" label="סיבה (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="reason.en" label="סיבה (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">פרטים</Typography>
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="days" label="ימים" fullWidth required />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="amount" label="כמות תכנים" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="videoamount" label="כמות וידאו" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="missionamount" label="כמות משימות" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="expertamount" label="כמות מומחים" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<BooleanInput source="active" label="פעיל" defaultValue={true} />
					</Grid>
				</Grid>
			</SimpleForm>
		</Create>
	);
};
export default PlanCreate;
